/**
 * @fileoverview gRPC-Web generated client stub for ASIC.Contracts.ServiceContracts.MulticaseLayer
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0-rc2
// source: IMultiUserService.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var protobuf$net_bcl_pb = require('./protobuf-net/bcl_pb.js')
const proto = {};
proto.ASIC = {};
proto.ASIC.Contracts = {};
proto.ASIC.Contracts.ServiceContracts = {};
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer = require('./IMultiUserService_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.LoginRequest,
 *   !proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.AccessTokenResult>}
 */
const methodDescriptor_MultiUserService_MultiLogin = new grpc.web.MethodDescriptor(
  '/ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserService/MultiLogin',
  grpc.web.MethodType.UNARY,
  proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.LoginRequest,
  proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.AccessTokenResult,
  /**
   * @param {!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.AccessTokenResult.deserializeBinary
);


/**
 * @param {!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.AccessTokenResult)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.AccessTokenResult>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserServiceClient.prototype.multiLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserService/MultiLogin',
      request,
      metadata || {},
      methodDescriptor_MultiUserService_MultiLogin,
      callback);
};


/**
 * @param {!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.AccessTokenResult>}
 *     Promise that resolves to the response
 */
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserServicePromiseClient.prototype.multiLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserService/MultiLogin',
      request,
      metadata || {},
      methodDescriptor_MultiUserService_MultiLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueRequest_String,
 *   !proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueResult_SaveResult>}
 */
const methodDescriptor_MultiUserService_RecoverPassword = new grpc.web.MethodDescriptor(
  '/ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserService/RecoverPassword',
  grpc.web.MethodType.UNARY,
  proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueRequest_String,
  proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueResult_SaveResult,
  /**
   * @param {!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueRequest_String} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueResult_SaveResult.deserializeBinary
);


/**
 * @param {!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueRequest_String} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueResult_SaveResult)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueResult_SaveResult>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserServiceClient.prototype.recoverPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserService/RecoverPassword',
      request,
      metadata || {},
      methodDescriptor_MultiUserService_RecoverPassword,
      callback);
};


/**
 * @param {!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueRequest_String} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.ValueResult_SaveResult>}
 *     Promise that resolves to the response
 */
proto.ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserServicePromiseClient.prototype.recoverPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ASIC.Contracts.ServiceContracts.MulticaseLayer.MultiUserService/RecoverPassword',
      request,
      metadata || {},
      methodDescriptor_MultiUserService_RecoverPassword);
};


module.exports = proto.ASIC.Contracts.ServiceContracts.MulticaseLayer;

